<template>
  <div class="ai-panel">
    <v-row>
      <v-col cols="12" lg="8">
        <v-card variant="outlined" rounded="lg" class="pa-4 mb-4">
          <div class="d-flex align-center ga-2 mb-6">
            <span class="text-body-1 font-weight-medium">风暴防护</span>
            <v-tooltip location="top" max-width="320">
              <template #activator="{ props: p }">
                <v-icon v-bind="p" size="20" color="medium-emphasis">mdi-help-circle-outline</v-icon>
              </template>
              <div class="text-caption">
                <strong>使能：</strong>开启后忽略预设限值，收到极端天气告警时以最大功率充电至 SOC 上限；天气结束后恢复原工作策略。<br>
                <strong>关闭：</strong>按标准工作策略运行。
              </div>
            </v-tooltip>
            <v-switch v-model="stormOn" hide-details color="primary" inset />
          </div>

          <div class="d-flex align-center ga-2 mb-2">
            <span class="text-body-2 font-weight-medium">工作策略</span>
            <v-icon size="18" color="medium-emphasis">mdi-help-circle-outline</v-icon>
          </div>
          <v-select
            v-model="workStrategy"
            :items="workItems"
            item-title="title"
            item-value="value"
            variant="outlined"
            density="compact"
            hide-details="auto"
            rounded="lg"
            class="mb-6"
          />

          <div class="text-subtitle-2 font-weight-semibold mb-3">电价</div>
          <div class="text-body-2 font-weight-medium mb-2">基本资料</div>
          <v-select
            v-model="currencyUnit"
            :items="['欧元', '人民币', '美元']"
            label="单位"
            variant="outlined"
            density="compact"
            hide-details="auto"
            rounded="lg"
            class="mb-4"
            style="max-width: 200px"
          />
          <div class="text-body-2 mb-2">方式</div>
          <v-radio-group v-model="priceMode" inline hide-details density="compact" class="mb-4">
            <v-radio label="动态电价" value="dynamic" color="primary" />
            <v-radio label="手动输入" value="manual" color="primary" />
          </v-radio-group>

          <template v-if="priceMode === 'dynamic'">
            <v-select
              v-model="provider"
              :items="['Nord Pool', 'EPEX', '自定义']"
              label="电力供应商"
              variant="outlined"
              density="compact"
              hide-details="auto"
              rounded="lg"
              class="mb-3"
            />
            <v-select
              v-model="zone"
              :items="['DK1', 'DK2', 'DE-LU']"
              label="竞价区"
              variant="outlined"
              density="compact"
              hide-details="auto"
              rounded="lg"
              class="mb-4"
            />
          </template>

          <div class="d-flex justify-end">
            <v-btn color="#2F59EB" variant="flat" rounded="lg">指令下发</v-btn>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4">
        <v-card variant="outlined" rounded="lg" class="weather-card pa-4">
          <div class="text-body-2 font-weight-medium mb-2">天气</div>
          <div class="weather-placeholder text-caption text-medium-emphasis">
            天气组件占位，可接入实况与预警接口
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const stormOn = ref(false)
const workStrategy = ref('profit')
const workItems = [
  { title: '收益最大化', value: 'profit' },
  { title: '峰谷套利', value: 'arbitrage' },
  { title: '需量控制', value: 'demand' },
]

const currencyUnit = ref('欧元')
const priceMode = ref('dynamic')
const provider = ref('Nord Pool')
const zone = ref('DK1')

defineExpose({
  getDraft: () => ({
    mode: 'aiStorm',
    stormOn: stormOn.value,
    workStrategy: workStrategy.value,
    currencyUnit: currencyUnit.value,
    priceMode: priceMode.value,
    provider: priceMode.value === 'dynamic' ? provider.value : null,
    zone: priceMode.value === 'dynamic' ? zone.value : null,
  }),
})
</script>

<style scoped>
.ai-panel {
  max-width: 1000px;
}
.weather-card {
  min-height: 200px;
  border-color: #e4e8f0 !important;
}
.weather-placeholder {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cfd4e2;
  border-radius: 8px;
  background: #fafbfd;
}
</style>
